import React from 'react';
import './CategoryCard.css';

interface CategoryCardProps {
  id: string;
  imageUrl: string;
  title: string;
  onClick?: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ imageUrl, title, onClick }) => {
  return (
    <div className="category-card" onClick={onClick} aria-label={`View ${title}`}>
      <div className="category-image">
        <img src={imageUrl} alt={title} loading="lazy" />
      </div>
      <h3 className="category-title">{title}</h3>
    </div>
  );
};

export default CategoryCard;